import {
  FinanceBalanceSheet,
  FinanceCashFlow,
  FinanceProfitLoss,
  FinanceReports,
  lazyWithRetry,
} from '@/pages/lazy';

export const CashCollectionReport = lazyWithRetry(() =>
  import('./CashCollectionReport').then((m) => ({
    default: m.CashCollectionReport,
  })),
);
export const ExpenseSummaryReport = lazyWithRetry(() =>
  import('./ExpenseSummaryReport').then((m) => ({
    default: m.ExpenseSummaryReport,
  })),
);
export const RefundsReport = lazyWithRetry(() =>
  import('./RefundsReport').then((m) => ({ default: m.RefundsReport })),
);
export const TreatmentProfitabilityReport = lazyWithRetry(() =>
  import('./TreatmentProfitabilityReport').then((m) => ({
    default: m.TreatmentProfitabilityReport,
  })),
);
export const PatientIncomeReport = lazyWithRetry(() =>
  import('./PatientIncomeReport').then((m) => ({
    default: m.PatientIncomeReport,
  })),
);
export const BranchComparisonReport = lazyWithRetry(() =>
  import('./BranchComparisonReport').then((m) => ({
    default: m.BranchComparisonReport,
  })),
);
export const ARAgingReport = lazyWithRetry(() =>
  import('./ARAgingReport').then((m) => ({ default: m.ARAgingReport })),
);
export const PatientStatementReport = lazyWithRetry(() =>
  import('./PatientStatementReport').then((m) => ({
    default: m.PatientStatementReport,
  })),
);
export const ProductionReport = lazyWithRetry(() =>
  import('./ProductionReport').then((m) => ({ default: m.ProductionReport })),
);
export const OffersLoyaltyReport = lazyWithRetry(() =>
  import('./OffersLoyaltyReport').then((m) => ({
    default: m.OffersLoyaltyReport,
  })),
);

/**
 * Every page the Reports section links to. A Reports page fetches the rest of
 * them once it is quiet (see lib/page-loads), so moving between reports waits
 * on figures only, not on code.
 */
export const REPORT_SECTION_PAGES = [
  FinanceReports,
  CashCollectionReport,
  FinanceProfitLoss,
  ARAgingReport,
  ExpenseSummaryReport,
  TreatmentProfitabilityReport,
  PatientIncomeReport,
  RefundsReport,
  FinanceBalanceSheet,
  FinanceCashFlow,
  BranchComparisonReport,
  PatientStatementReport,
  ProductionReport,
  OffersLoyaltyReport,
];
